import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'public'
if(localStorage.getItem('userRole')) initialRole = localStorage.getItem('userRole')

export default new AclCreate({
  initial: initialRole,
  //notfound: '/pages/not-authorized',
  router,
  acceptLocalRules: false,
  globalRules: {
    admin: new AclRule('admin').generate(),
    finance: new AclRule('finance').or('editor').generate(),
    editor: new AclRule('editor').or('admin').generate(),
    logged: new AclRule('logged').or('admin').or('editor').or('finance').generate(),
    public: new AclRule('public').or('admin').or('editor').or('finance').generate(),
  },
  middleware: async acl => {
    //await timeout(2000) // call your api
    await fetch(store.state.API_URL+'validate/token', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: "token="+localStorage.getItem("token")
    })
    .then((response) => response.text())
    .then((responseData) => {
      var dados = JSON.parse(responseData);
      if(dados.token == false)
      {
        acl.change('public');
      }
      else
      {
        //
        acl.change(dados.rule);
        console.log(dados.rule);
      }
    })
    .catch((error) => {
      acl.change('public');
    });

  }
})
